<app-admin-conteiner>
  <section content>
    <app-admin-title *ngIf="breadcrumb"></app-admin-title>
    <ng-container
      *ngIf="!loading; then businessPage; else businessLoading"
    ></ng-container>
  </section>
</app-admin-conteiner>

<ng-template #businessPage>
  <ng-container
    *ngIf="showTabs; then businessTabs; else businessForm"
  ></ng-container>
</ng-template>

<ng-template #businessTabs>
  <app-admin-tabs [titles]="titles" [tabIndex]="tabIndex">
    <div content1>
      <app-business-form></app-business-form>
    </div>
    <div content2>
      <app-menu-list [businessId]="businessId"></app-menu-list>
    </div>
    <div content3>
      <app-extra-list [businessId]="businessId"></app-extra-list>
    </div>
  </app-admin-tabs>
</ng-template>

<ng-template #businessForm>
  <app-business-form></app-business-form>
</ng-template>

<ng-template #businessLoading>
  <app-loading message="Cargando..."></app-loading>
</ng-template>
